import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";
import { ITaskProgramFormDTO, ITaskProgramFormViewDTO, ITaskProgramStoresViewDTO } from "../../libs/coreapi-dto/dirs/taskProgram";

export class TaskProgramProvider extends DictionaryDataProvider<ITaskProgramFormViewDTO,ITaskProgramFormDTO>
{
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }
    
    getDataRequest(): Promise<IDictionaryRequest<ITaskProgramFormViewDTO,ITaskProgramFormDTO>> {
        return this._coreApiService.taskProgramRequest
    }

     viewStores(idGlobal: string, body: IViewBody, callback: (entity: ITaskProgramStoresViewDTO[], totalCount) => void) {
            this._coreApiService.taskProgramRequest
                .then(r => r.viewStores(idGlobal, body, e => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback(e.data.entities, e.data.totalCount)
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.detail ?? 'ServiceDataProvider getView !isCompleted');
                }))
        }

}